module.exports = __webpack_public_path__ + "static/media/9DESA25.93ff5b7a.jpg";